import { FormElement, FormError, FormSubmission } from '@uplift/types';
import { restClient } from '../../client';

export type ReviewFormRequest = {
  submission_id: string;
};

export type ReviewFormResponse =
  | {
    error: FormError;
  }
  | {
    elements: FormElement[];
    responses: FormSubmission;
  };

export const reviewForm = (data: ReviewFormRequest) =>
  restClient.request<ReviewFormResponse>('/api/v1/form/review', {
    method: 'POST',
    data
  });
